import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { Button } from '../components/ui/button';
import { X } from 'lucide-react';

const CATEGORIES = ['Weather', 'Supply Issues', 'Health', 'Unrest', 'Other'];

export const FilterBar = ({ filters, onFilterChange, filterOptions, onClearFilters }) => {
  const hasActiveFilters = filters.category || filters.country || filters.city;

  return (
    <div className="space-y-3" data-testid="filter-bar">
      <div className="flex items-center justify-between">
        <span className="text-sm text-zinc-400 font-medium">Filters</span>
        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearFilters}
            className="text-xs text-zinc-500 hover:text-zinc-300 h-auto p-1"
            data-testid="clear-filters-btn"
          >
            <X className="w-3 h-3 mr-1" />
            Clear
          </Button>
        )}
      </div>
      
      <div className="flex flex-wrap gap-2">
        {/* Category Filter */}
        <Select
          value={filters.category || "all"}
          onValueChange={(value) => onFilterChange('category', value === 'all' ? '' : value)}
        >
          <SelectTrigger 
            className="w-[140px] bg-zinc-900 border-zinc-700 text-zinc-100 text-sm h-9"
            data-testid="filter-category"
          >
            <SelectValue placeholder="Category" />
          </SelectTrigger>
          <SelectContent className="bg-zinc-900 border-zinc-700">
            <SelectItem value="all" className="text-zinc-300">All Categories</SelectItem>
            {CATEGORIES.map(cat => (
              <SelectItem key={cat} value={cat} className="text-zinc-300">{cat}</SelectItem>
            ))}
          </SelectContent>
        </Select>

        {/* Country Filter */}
        <Select
          value={filters.country || "all"}
          onValueChange={(value) => onFilterChange('country', value === 'all' ? '' : value)}
        >
          <SelectTrigger 
            className="w-[140px] bg-zinc-900 border-zinc-700 text-zinc-100 text-sm h-9"
            data-testid="filter-country"
          >
            <SelectValue placeholder="Country" />
          </SelectTrigger>
          <SelectContent className="bg-zinc-900 border-zinc-700">
            <SelectItem value="all" className="text-zinc-300">All Countries</SelectItem>
            {filterOptions.countries.map(country => (
              <SelectItem key={country} value={country} className="text-zinc-300">{country}</SelectItem>
            ))}
          </SelectContent>
        </Select>

        {/* City Filter */}
        <Select
          value={filters.city || "all"}
          onValueChange={(value) => onFilterChange('city', value === 'all' ? '' : value)}
        >
          <SelectTrigger 
            className="w-[140px] bg-zinc-900 border-zinc-700 text-zinc-100 text-sm h-9"
            data-testid="filter-city"
          >
            <SelectValue placeholder="City" />
          </SelectTrigger>
          <SelectContent className="bg-zinc-900 border-zinc-700">
            <SelectItem value="all" className="text-zinc-300">All Cities</SelectItem>
            {filterOptions.cities.map(city => (
              <SelectItem key={city} value={city} className="text-zinc-300">{city}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};
